import React from "react"
import {findDOMNode} from "react-dom"

import PopoverAddColumn from "../../../../../../gd-modules/common/add-column-new/popover/popover"
import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import FieldSelectField from "../../select-group-field"
import convertFieldsStructureToConfig, {
    FieldSelectorConfig
} from "../../../../../../gd-modules/common/add-column-new/convert-fields-structure"
import GroupBy from "../../../../../../gd/manager/group-by/group-by-model"
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const";

export default function FieldSelectGroupField_Popover(props:any) {

    const field : FieldSelectField = props.field

    const config: FieldSelectorConfig = convertFieldsStructureToConfig(field.fieldsStructure)
    const groupBy: GroupBy | undefined = props.field.getViewValue(props.model)

    const onSelect = (fieldId:ID | null, params: any) => {
        props.parent.hidePopover()

        props.parent.onValueChange(new GroupBy({
            fieldId,
            sortDirection: groupBy?.sortDirection,
            params,
        }, field.fields))
    }

    const popoverPosition = new PopoverPosition({
        attachment      : props.options?.attachment,
        targetAttachment: props.options?.targetAttachment,
        offset          : props.offset,
        attachmentType  : PopoverAttachmentType.HORIZONTAL,
    })

    return (
        <Popover
            popoverClass        = "gd-popover-add-column-new h-300"
            position            = {popoverPosition}
            onClickOutside      = {()=>{props.parent.hidePopover()}}
            getTargetFunc       = {()=>findDOMNode(props.parent)}
        >
            <PopoverAddColumn
                config              = {config}
                fields              = {field.fields.models}
                columns             = {[{
                    fieldId : groupBy?.field?.fieldId,
                    params  : groupBy?.params
                }]}
                selectedFieldIds    = {[]}
                mandatoryColumnsIds = {[]}
                noValueOption       = {field.noValueOption ? {icon: field.noValueOptionIcon, label: field.noValueOptionLabel} : undefined}
                isAddVisible        = {false}
                showModifierOptions = {true}
                hidePopover         = {props.parent.hidePopover}
                onToggleColumn      = {onSelect}
                onNewCustomField    = {()=>{}}
            />
        </Popover>
    )
}
